import { trackCustomEvent } from "gatsby-plugin-google-analytics"

export type GATrackCustomEventParams = {
    // string - required - The object that was interacted with (e.g.video)
    category: string,
    // string - required - Type of interaction (e.g. 'play')
    action: string,
    // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
    label?: string,
    // number - optional - Numeric value associated with the event. (e.g. A product ID)
    value?: number,
    // GA4
    params?: any
}

export type ITMEventParams = {
    itm_source: string,
    itm_medium: string,
    itm_campaign: string,
}

class Service {
    public getDeviceId() {
        const deviceId = localStorage.getItem('FINDDOC_DEVICE_ID');
        if (!deviceId) {
            const newDeviceId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            localStorage.setItem('FINDDOC_DEVICE_ID', newDeviceId);
            return newDeviceId;
        }
        return deviceId;
    }

    public trackCustomEvent(params: GATrackCustomEventParams) {
        trackCustomEvent(params);
        if (window && (window as any).dataLayer) {
            (window as any).dataLayer.push({
                event: "ga_event",
                ga_event_category: params.category,
                ga_event_action: params.action,
                ga_event_label: params.label,
                ...params.params,
            })
        }
    }

    public trackSelftest(slug: string, action: string, additionalInformation?: string) {
        this.trackCustomEvent({
            category: `Self-tests_${slug}`,
            action: `${action}${additionalInformation ? `_${additionalInformation}` : ''}`,
        });
    }

    public getNavigateUrlWithITMQuery(url: string, { itm_source, itm_medium, itm_campaign }: ITMEventParams, preserveUtm: boolean = true) {
        const res = `${url}?itm_source=${itm_source}&itm_medium=${itm_medium}&itm_campaign=${itm_campaign}`;
        if (preserveUtm) {
            const utm = this.getUTM();
            if (utm) {
                return `${res}&utm_campaign=${utm.utm_campaign}&utm_medium=${utm.utm_medium}&utm_source=${utm.utm_source}`
            }
        }
        return res;
    }

    public getUTM() {
        if (typeof window === 'undefined') {
            return undefined;
        }

        const params = new URLSearchParams(window.location.search);
        if (!params.has("utm_content") && !params.has("utm_medium") && !params.has("utm_source") && !params.has("utm_campaign")) {
            return undefined;
        }

        const utm_content = params.get("utm_content") ?? undefined;
        const utm_medium = params.get("utm_medium") ?? undefined;
        const utm_source = params.get("utm_source") ?? undefined;
        const utm_campaign = params.get("utm_campaign") ?? undefined;

        const utm = {
            utm_content,
            utm_medium,
            utm_source,
            utm_campaign,
        };

        return utm;
    }
}

export const TrackingService = new Service();
